/* ric2-script.js — chọn gói trên trang "Rooted in Christ" V2.
 *
 * Việc DUY NHẤT của tệp này: khi khách đổi gói thì đồng bộ giá và tên gói ở
 * khung mua và thanh cố định, và hiện đúng form của gói đó.
 *
 * LUẬT CỨNG: không bao giờ gỡ `disabled` của một nút mua, và không bao giờ đổi
 * `value` của ô variant id. Nút nào mở là do Liquid đã xác minh ở máy chủ.
 *
 * Nút "Continue" dưới bảng gói bấm hộ nút mua của form gói đang chọn (từ 29/09/2026),
 * khách khỏi cuộn xuống khung mua rồi bấm thêm lần nữa. Nút mua bị khoá hoặc không tìm
 * thấy form thì để nguyên hành vi neo xuống #khung-mua — không mở khoá gì cả.
 *
 * Máy chủ in CẢ BA form và không ẩn form nào. Việc thu gọn lại còn một form là
 * của tệp này. Nên nếu tệp không tải được, hoặc khách tắt JavaScript, trang chỉ
 * dài hơn chứ không mất gói nào — mỗi form có sẵn nhãn tên gói và giá riêng.
 */
(function () {
  'use strict';

  var goc = document.querySelector('.ric2-root');
  if (!goc) return;

  var radio = goc.querySelectorAll('.pbg__radio');
  if (!radio.length) return;

  var oGia = goc.querySelectorAll('[data-ric2-gia-chon]');
  var oTen = goc.querySelectorAll('[data-ric2-ten-chon]');
  var form = goc.querySelectorAll('[data-ric2-form]');

  function dat(nut) {
    if (!nut) return;
    var gia = nut.getAttribute('data-gia') || '';
    var ten = nut.getAttribute('data-ten') || '';

    for (var i = 0; i < oGia.length; i++) oGia[i].textContent = gia;
    for (var j = 0; j < oTen.length; j++) oTen[j].textContent = ten;

    // Thẻ gói: chuyển dấu nổi bật sang thẻ đang chọn.
    for (var k = 0; k < radio.length; k++) {
      var the = radio[k].closest('.pbg__the');
      if (the) the.classList.toggle('is-chon', radio[k] === nut);
    }

    // Form: chỉ đổi form nào ĐANG HIỆN. Không đụng tới disabled.
    for (var m = 0; m < form.length; m++) {
      form[m].hidden = form[m].getAttribute('data-ric2-form') !== nut.value;
    }
  }

  for (var i = 0; i < radio.length; i++) {
    radio[i].addEventListener('change', function () { dat(this); });
    if (radio[i].checked) dat(radio[i]);
  }

  var tiep = goc.querySelector('.pbg__nut');
  if (tiep) {
    tiep.addEventListener('click', function (e) {
      var chon = goc.querySelector('.pbg__radio:checked');
      var f = chon ? document.getElementById('ric2-form-' + chon.value) : null;
      var nutMua = f ? f.querySelector('button[type="submit"][name="add"]') : null;
      if (!nutMua || nutMua.disabled) return;

      e.preventDefault();
      if (tiep.getAttribute('aria-busy') === 'true') return;
      tiep.setAttribute('aria-busy', 'true');
      setTimeout(function () { tiep.removeAttribute('aria-busy'); }, 3000);
      nutMua.click();
    });
  }

  // "Change plan" đưa khách ngược lên bảng gói, đúng như nút Continue đưa xuống.
  var doi = goc.querySelector('[data-ric2-doi]');
  if (doi) {
    doi.addEventListener('click', function () {
      var neo = document.getElementById('cac-goi');
      if (neo) neo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
})();
